module.exports = "#map-legend {\r\n    background-color: white;\r\n    padding: 1em;\r\n}\r\n\r\n#map-legend img {\r\n    max-width: 50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/home-map/home-map.component.css
// module id = ./src/app/components/ui/home-map/home-map.component.css
// module chunks = main